var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner h-100",on:{"click":_vm.toPlan}},[_c('div',{staticClass:"banner-inner h-100"},[_c('div',{staticClass:"banner-text",domProps:{"innerHTML":_vm._s(_vm.$t('BannerPlans.text'))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }